import { render } from "./paragraphBlock.vue?vue&type=template&id=2095667c&ts=true"
import script from "./paragraphBlock.vue?vue&type=script&lang=ts"
export * from "./paragraphBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__